module.exports = __webpack_public_path__ + "img/ico_error_email.71f4b480.svg";